<main @fade>
  <nb-card>
    <nb-card-body>
      <nb-action (click)="toggleOpened()" [hidden]="isOpened || itemPage"
                 [icon]="isOpened ? 'arrow-ios-back-outline' : 'arrow-ios-forward-outline'"
                 class="catalog-show__icon" i18n-title="@@ToggleTree"
                 title="{{ isOpened ? 'скрыть дерево':'показать дерево' }}"></nb-action>

      <div (onResize)="onResize($event)" [ngClass]="isOpened ? '':'hidden-center'" [style.width]="width + 'px'" class="resizable" resizable>
        <div [hidden]="itemPage" [ngClass]="isOpened ? '':'hidden-center'" class="flex-item">
          <nb-card [hidden]="!isOpened">
            <nb-card-header class="icon__catalog-tree">
              <!--                <div *ngIf="isDownloadFile && canUpload" class="dam__fixed-upload">-->
              <!--                  <div (click)="closeOpenedDownload()" class="content__bg"></div>-->
              <!--                  <div class="content">-->
              <!--                    <div class="icon__upload">-->
              <!--                      <img alt="" src="assets/images/dam/upload.svg">-->
              <!--                    </div>-->
              <!--                    <div *ngIf="!isUploading" class="content-block">-->
              <!--                      <label (fileOver)="fileOver($event)" (onFileDrop)="upload()"-->
              <!--                             [ngClass]="{'file-over': true}"-->
              <!--                             [uploader]="uploader"-->
              <!--                             class="well my-drop-zone"-->
              <!--                             for="document-uploader-input"-->
              <!--                             i18n="@ClickOrDragDocument"-->
              <!--                             ng2FileDrop>Кликните или перетащите сюда файл</label>-->
              <!--                      <input (change)="upload()" [uploader]="uploader" id="document-uploader-input" multiple ng2FileSelect-->
              <!--                             style="display:none"-->
              <!--                             type="file"/>-->
              <!--                    </div>-->
              <!--                    <nb-alert *ngIf="isUploading" size="small" status="warning">Идет загрузка. Дождитесь окончания...</nb-alert>-->
              <!--                  </div>-->
              <!--                </div>-->
              <span i18n="@@Categories">Папки</span>
              <nb-action (click)="toggleDeleted()" [icon]="showDeleted ? 'eye' : 'eye-outline'" i18n-nbTooltip="@@ShowDeleted"
                         nbTooltip="Показать неактивные"></nb-action>
              <nb-action (click)="reindex()" *nbIsGranted="['reindex', 'catalog_tree']"
                         [disabled]="reindexing"
                         i18n-nbTooltip="@@ElasticReindexCatalog"
                         icon="refresh-outline"
                         nbTooltip="Переиндексировать структуру каталогов">
              </nb-action>
              <nb-action (click)="toggleOpened()" i18n-nbTooltip="@@HideTree"
                         icon="menu-arrow-outline"
                         nbTooltip="Скрыть дерево">
              </nb-action>
              <nb-action [routerLink]="'create'" i18n-nbTooltip="@@AddRootCategory"
                         icon="plus-outline"
                         nbTooltip="Добавить корневой раздел">
              </nb-action>
            </nb-card-header>
            <nb-card-body class="switch" style="overflow: visible">
              <app-compo-tree [treeData]="data1">
                <ng-template let-item>
                  <div [ngClass]="{deletedCatalog: item.deleted === true, disabledCatalog: item.enabled === false, 'tree-node-selected': item.id==catalogId}"
                       class="tree-item-wrapper"
                  >
                    <div (click)="setId(item.id, true)" class="tree-item" title="{{ item.header }}">
                      <span>{{ item.header }}</span>
                    </div>

                    <ng-container *ngTemplateOutlet="ActionButtons; context: {id: item.id}"></ng-container>
                    <span (click)="setId(item.id, true)" *ngIf="!item.lastLevel" class="expand-collapse"><nb-icon [icon]="!item.expanded ? 'chevron-down-outline':'chevron-up-outline'"></nb-icon></span>
                    <span *ngIf="item.lastLevel" class="expand-collapse expand-collapse-fake"></span>
                  </div>
                </ng-template>
              </app-compo-tree>

              <ng-template #ActionButtons let-id="id" let-lastLevel="lastLevel">
                <button nbButton status="control" [matMenuTriggerFor]="menu">
                  <nb-icon icon="more-vertical-outline"/>
                </button>

                <mat-menu #menu="matMenu">
                  <div>
                    <button
                      *ngIf="lastLevel !== true && canUpload"
                      [routerLink]="['create', id]"
                      mat-menu-item
                    >
                      <nb-icon icon="plus"></nb-icon>&nbsp;
                      <span i18n="@@AddSubCategory">Новая папка</span>
                    </button>
                    <button
                      *ngIf="canUpload"
                      [routerLink]="['edit', id]"
                      mat-menu-item
                    >
                      <nb-icon icon="edit-outline"></nb-icon>&nbsp;
                      <span i18n="@@Edit">Изменить</span>
                    </button>
                    <button (click)="downloadDamCatalog(id)" mat-menu-item>
                      <nb-icon icon="download-outline"></nb-icon>&nbsp;
                      <span i18n="@@DownloadFolder">Скачать</span>
                    </button>
                    <button
                      (click)="shareDamItems(id)"
                      *ngIf="canUpload"
                      mat-menu-item
                    >
                      <nb-icon icon="share-outline"></nb-icon>&nbsp;
                      <span i18n="@@shareFolder">Поделиться разделом</span>
                    </button>
                    <button
                      (click)="createExternalLink(id)"
                      *ngIf="canUpload"
                      mat-menu-item
                    >
                      <nb-icon icon="link-outline"></nb-icon>&nbsp;
                      <span i18n="@@ExternalUpload">Ссылка на загрузку</span>
                    </button>
                    <button
                      (click)="onDeleteConfirm(id)"
                      *ngIf="canUpload"
                      mat-menu-item
                    >
                      <nb-icon icon="close-outline"></nb-icon>&nbsp;
                      <span i18n="@@Delete">Удалить</span>
                    </button>
                  </div>
                </mat-menu>
              </ng-template>


              <!--                  <div class="icon__catalog-tree">-->
              <!--                    <a (click)="navToPersonal()" [ngClass]="folder=='shared-with-me'?'dam-left-panel-active':''" i18n="@@basket" class="basket-garbage"><nb-icon icon="person-done-outline"></nb-icon>Доступные мне</a>-->
              <!--                  </div>-->

              <!--                  <div class="icon__catalog-tree">-->
              <!--                    <a (click)="navToBasket()" [ngClass]="folder=='basket'?'dam-left-panel-active':''" i18n="@@basket" class="basket-garbage"><nb-icon icon="trash-outline"></nb-icon>Корзина</a>-->
              <!--                  </div>-->
            </nb-card-body>
          </nb-card>
        </div>
        <div class="grabber" grabber></div>
      </div>
      <div [ngClass]="isOpened ? '':'fixed-center'" class="flex-item__right" style="flex: 1 1 auto;">
        <router-outlet></router-outlet>
      </div>
    </nb-card-body>
  </nb-card>
</main>
